export default "__VITE_ASSET__th$MGMia__"